export default {
  // Introduce Row
  'dashboard.analysis.total-sales': '总收入 (GGR)',
  'dashboard.analysis.visits': '今日总登录数',
  'dashboard.analysis.payments': '活跃所有者',
  'dashboard.analysis.operational-effect': '系统健康',
  'dashboard.analysis.indicator-introduction': '指标介绍',
  'dashboard.analysis.active-players': '活跃玩家',
  'dashboard.analysis.daily-players': '每日玩家',
  'dashboard.analysis.turnover': '营业额',
  'dashboard.analysis.week-on-week': '周环比',
  'dashboard.analysis.day-on-day': '日环比',
  'dashboard.analysis.new-sites': '总登录数',
  'dashboard.analysis.daily-visits': '日登录数',
  'dashboard.analysis.weekly-comparison': '周',
  'dashboard.analysis.daily-comparison': '日',
  'dashboard.analysis.daily-sales': '日GGR',
  'pages.game.badges.new': 'New',
  'pages.game.badges.top-rated': 'Top Rated',
  'pages.game.badges.hot': 'Hot',
  'pages.common.add': 'Add',
  'pages.game.badges': 'Game Badges',
  'pages.game.edit': 'Edit Game',

  // Sales Card
  'dashboard.analysis.ggr-by-provider': '按供应商的总收入',
  'dashboard.analysis.visits-ranking': '访问排名',
  'dashboard.analysis.ggr-by-provider-ranking': '我们的顶级供应商排名',
  'dashboard.analysis.all-day': '今天',
  'dashboard.analysis.all-week': '本周',
  'dashboard.analysis.all-month': '本月',
  'dashboard.analysis.all-year': '今年',
  'dashboard.analysis.today': '今天',
  'dashboard.analysis.week': '周',
  'dashboard.analysis.month': '月',
  'dashboard.analysis.year': '年',

  // Top Search -> Top Vendors
  'dashboard.analysis.online-top-search': '顶级游戏供应商',
  'dashboard.analysis.search-users': '游戏总数',
  'dashboard.analysis.per-capita-search': '平均游戏导入',
  'dashboard.analysis.table.rank': '排名',
  'dashboard.analysis.table.search-keyword': '供应商名称',
  'dashboard.analysis.table.users': '游戏数量',
  'dashboard.analysis.table.weekly-range': '增长率',
  'pages.org.hierarchy.site': '网络',

  // Proportion Sales
  'dashboard.analysis.the-proportion-of-sales': '平台组成',
  'dashboard.analysis.channel.all': '网站阶段',
  'dashboard.analysis.channel.online': '游戏类型',
  'dashboard.analysis.channel.stores': '货币',

  // Offline Data
  'dashboard.analysis.offline-data': '所有者质量',
  'dashboard.analysis.conversion-rate': '生产转化率',

  'monitor.trading.title': '实时交易状态',
  'monitor.trading.total-turnover': '今日总营业额',
  'monitor.trading.target-completion': '每日目标完成',
  'monitor.trading.time-remaining': '剩余时间',
  'monitor.trading.live-tps': '实时TPS',

  'monitor.trend.traffic': '实时流量',
  'monitor.rtp.title': '实时RTP % (庄家优势)',
  'monitor.rtp.status.profitable': '盈利',
  'monitor.rtp.status.risk': '高风险',
  'monitor.rtp.status.critical': '严重亏损',

  'monitor.category.proportion': '游戏类型比例',
  'monitor.category.top-ranks': '通用',
  'monitor.category.none': '通用',
  'monitor.category.electronic': '电子',
  'monitor.category.slot': '老虎机',
  'monitor.category.table': '桌面游戏',
  'monitor.category.live': '真人赌场',
  'monitor.category.lottery': '彩票',
  'monitor.category.fish': '捕鱼游戏',
  'monitor.category.arcade': '街机',
  'monitor.category.sport': '体育',
  'monitor.category.esport': '电子竞技',

  'pages.header.selectSite': '网站',

  'vendor.ggr.card.category.none': '通用',
  'vendor.ggr.card.category.electronic': '电子',
  'vendor.ggr.card.category.slot': '老虎机',
  'vendor.ggr.card.category.table': '桌面游戏',
  'vendor.ggr.card.category.live': '真人赌场',
  'vendor.ggr.card.category.lottery': '彩票',
  'vendor.ggr.card.category.fish': '捕鱼游戏',
  'vendor.ggr.card.category.arcade': '街机',
  'vendor.ggr.card.category.sport': '体育',
  'vendor.ggr.card.category.esport': '电子竞技',
  'pages.header.switchingSite': '切换网站中...',

  // Analytics translations
  'analytics.today': '今天',
  'analytics.week': '周',
  'analytics.month': '月',
  'analytics.year': '年',
  'analytics.overview': '概览',
  'analytics.players': '玩家活动',
  'analytics.finance': '财务',
  'analytics.products': '产品',
  'analytics.bonus': '奖金与成本',
  'analytics.markets': '市场',
  'analytics.ggr': 'GGR',
  'analytics.ngr': 'NGR',
  'analytics.activePlayers': '活跃玩家',
  'analytics.houseEdge': '庄家优势',
  'analytics.revenueTrend': '收入趋势 (GGR vs NGR)',
  'analytics.productMix': '产品组合',
  'analytics.playerFunnel': '玩家漏斗',
  'analytics.activePlayersByProduct': '按产品活跃玩家',
  'analytics.deposits': '存款',
  'analytics.withdrawals': '取款',
  'analytics.netDeposits': '净存款',
  'analytics.avgDeposit': '平均存款',
  'analytics.turnoverVsWinnings': '营业额 vs 奖金',
  'analytics.depositBreakdown': '存款明细',
  'analytics.depositBreakdown.total': '总计',
  'analytics.depositBreakdown.ftdCount': 'FTD 数量',
  'analytics.depositBreakdown.depositCount': '存款次数',
  'analytics.depositBreakdown.uniqueDepositors': '唯一存款人',
  'analytics.productPerformance': '产品性能比较',
  'analytics.totalBonus': '总奖金',
  'analytics.bonusWithdrawn': '已提取奖金',
  'analytics.cashback': '返现',
  'analytics.bonusCostRatio': '奖金成本比率',
  'analytics.bonusImpact': '奖金对收入影响',
  'analytics.marketPerformance': '市场表现',
  'analytics.registrations': '注册',
  'analytics.ftds': 'FTDs',
  'analytics.ftdConversion': 'FTD 转化率',
  'analytics.depositPenetration': '存款渗透率',
  'analytics.turnover': '营业额',
  'pages.login.accountLogin.tab': '会员专区',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.username.placeholder': '成员 ID / 用户名',
  'pages.login.username.required': '请输入您的用户名!',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入您的密码!',
  'pages.login.totp.placeholder': '2FA Authenticator',
  'pages.login.hubOwnerLogin.tab': 'Gateway Owner Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Rule Title',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.language.updated': 'อัปเดตการแสดงผลภาษาสำเร็จ',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '选项',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅提醒',
  'pages.searchTable.title': 'ITABLES',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.id': 'ID',
  'pages.searchTable.balance': '余额',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.searchTable.name': 'name',
  'pages.searchTable.nameAccountStatus.sandbox': '沙盒',
  'pages.searchTable.nameAccountStatus.production': '生产',
  'pages.searchTable.nameAccountStatus.ban': '禁用',
  'pages.searchTable.nameAccountStatus.pause': '暂停',
  'pages.searchTable.search': '搜索',
  'pages.searchTable.reset': '重置',
  'pages.vendor.updateTitle': 'Vendor Configuration',
  'pages.vendor.createdAt': '创建时间',
  'pages.vendor.gatewayId': 'Gateway ID',
  'pages.vendor.maintenance': '维护状态',


  // Profile Basic
  'pages.profile.basic.time': '时间',
  'pages.profile.basic.rate': '当前进度',
  'pages.profile.basic.status': '状态',
  'pages.profile.basic.status.success': '成功',
  'pages.profile.basic.status.processing': '进行中',
  'pages.profile.basic.operator': '操作员ID',
  'pages.profile.basic.cost': '耗时',
  'pages.profile.basic.total': '总计',
  'pages.profile.basic.good.id': '商品编号',
  'pages.profile.basic.good.name': '商品名称',
  'pages.profile.basic.good.barcode': '商品条码',
  'pages.profile.basic.good.price': '单价',
  'pages.profile.basic.good.num': '数量（件）',
  'pages.profile.basic.good.amount': '金额',
  'pages.profile.basic.refund': '退款申请',
  'pages.profile.basic.pickup.number': '取货单号',
  'pages.profile.basic.pickup.status': '状态',
  'pages.profile.basic.pickup.status.picked': '已取货',
  'pages.profile.basic.sale.number': '销售单号',
  'pages.profile.basic.child.order': '子订单',
  'pages.profile.basic.user.info': '用户信息',
  'pages.profile.basic.user.name': '用户姓名',
  'pages.profile.basic.user.phone': '联系电话',
  'pages.profile.basic.user.express': '常用快递',
  'pages.profile.basic.user.address': '取货地址',
  'pages.profile.basic.user.remark': '备注',
  'pages.profile.basic.user.remark.none': '无',
  'pages.profile.basic.total.id': '总计',
  'pages.profile.basic.user.name.val': '付小小',
  'pages.profile.basic.user.express.val': '菜鸟仓储',
  'pages.profile.basic.user.address.val': '浙江省杭州市西湖区万塘路18号',
  'pages.profile.basic.return.goods': '退货商品',
  'pages.profile.basic.return.progress': '退货进度',

  // Profile Advanced
  'pages.profile.advanced.op1': '操作一',
  'pages.profile.advanced.op2': '操作二',
  'pages.profile.advanced.op3': '操作三',
  'pages.profile.advanced.main.op': '主操作',
  'pages.profile.advanced.opt1': '选项一',
  'pages.profile.advanced.opt2': '选项二',
  'pages.profile.advanced.opt3': '选项三',
  'pages.profile.advanced.log1': '操作日志一',
  'pages.profile.advanced.log2': '操作日志二',
  'pages.profile.advanced.log3': '操作日志三',
  'pages.profile.advanced.type': '操作类型',
  'pages.profile.advanced.operator': '操作人',
  'pages.profile.advanced.result': '执行结果',
  'pages.profile.advanced.result.success': '成功',
  'pages.profile.advanced.result.reject': '驳回',
  'pages.profile.advanced.time': '操作时间',
  'pages.profile.advanced.memo': '备注',
  'pages.profile.advanced.status': '状态',
  'pages.profile.advanced.status.pending': '待审批',
  'pages.profile.advanced.amount': '订单金额',
  'pages.profile.advanced.creator': '创建人',
  'pages.profile.advanced.product': '订购产品',
  'pages.profile.advanced.create.time': '创建时间',
  'pages.profile.advanced.rel.doc': '关联单据',
  'pages.profile.advanced.effect.date': '生效日期',
  'pages.profile.advanced.remind': '请于两个工作日内确认',
  'pages.profile.advanced.urge': '催一下',
  'pages.profile.advanced.no.response': '未响应',
  'pages.profile.advanced.cost': '耗时：',
  'pages.profile.advanced.hours': '小时',
  'pages.profile.advanced.minutes': '分钟',
  'pages.profile.advanced.detail': '详情',
  'pages.profile.advanced.rule': '规则',
  'pages.profile.advanced.order.no': '单号：',
  'pages.profile.advanced.flow': '流程进度',
  'pages.profile.advanced.step1': '创建项目',
  'pages.profile.advanced.step2': '部门初审',
  'pages.profile.advanced.step3': '财务复核',
  'pages.profile.advanced.step4': '完成',
  'pages.profile.advanced.user.info': '用户信息',
  'pages.profile.advanced.user.name': '用户姓名',
  'pages.profile.advanced.user.card': '会员卡号',
  'pages.profile.advanced.user.id': '身份证',
  'pages.profile.advanced.user.phone': '联系方式',
  'pages.profile.advanced.user.address': '联系地址',
  'pages.profile.advanced.info.group': '信息组',
  'pages.profile.advanced.data': '某某数据',
  'pages.profile.advanced.update.time': '该数据更新时间',
  'pages.profile.advanced.data.desc': '数据说明',
  'pages.profile.advanced.multi.group': '多层级信息组',
  'pages.profile.advanced.group.name': '组名称',
  'pages.profile.advanced.manager': '负责人',
  'pages.profile.advanced.role': '角色码',
  'pages.profile.advanced.dept': '所属部门',
  'pages.profile.advanced.expire': '过期时间',
  'pages.profile.advanced.desc': '描述',
  'pages.profile.advanced.scientific.name': '学名',
  'pages.profile.advanced.call.records': '用户近半年来电记录',
  'pages.profile.advanced.creator.val': '曲丽丽',
  'pages.profile.advanced.product.val': 'XX 服务',
  'pages.profile.advanced.username.zhou': '周毛毛',
  'pages.profile.advanced.username.wu': '吴加号',
  'pages.profile.advanced.username.lin': '林东东',
  'pages.profile.advanced.user.name.val': '付小小',
  'pages.profile.advanced.user.address.val':
    '曲丽丽 18100000000 浙江省杭州市西湖区黄姑山路工专路交叉路口',
  'pages.profile.advanced.dept.val': 'XX公司 - YY部',
  'pages.profile.advanced.desc.val':
    '这段描述很长很长很长很长很长很长很长很长...',
  'pages.profile.advanced.scientific.name.val':
    'Citrullus lanatus (Thunb.) Matsum. et Nakai一年生蔓生藤本；茎、枝粗壮，具明显的棱。卷须较粗..',

  // Control Center
  'pages.controlCenter.title': '控制中心',
  'pages.controlCenter.description': '管理您的 AI 服务和资源分配',
  'pages.controlCenter.mode': 'Enviroment: {mode}',
  'pages.controlCenter.sandbox': '沙盒',
  'pages.controlCenter.seamless': '无缝',
  'pages.controlCenter.syncHubs': '同步所有 Gateway',
  'pages.controlCenter.saveConfig': '保存配置',
  'pages.controlCenter.budgetBalance': '预算余额',
  'pages.controlCenter.site_balance': 'Site Value',
  'pages.controlCenter.balance': 'Account Balance',
  'pages.controlCenter.site_balance_virtual_complimentary': '虚拟赠送',
  'pages.controlCenter.creditType': '信用类型',
  'pages.controlCenter.activeHubs': '活跃 Gateway',
  'pages.controlCenter.online': '在线',
  'pages.controlCenter.ownerName': '所有者名称',
  'pages.controlCenter.id': 'ID',
  'pages.controlCenter.memberStatus': 'Enviroment Status',
  'pages.controlCenter.ownerNotFound': '未找到所有者信息',
  'pages.controlCenter.configSaved': '配置已保存',
  'pages.controlCenter.syncFailed': '请求中心同步失败',
  'pages.controlCenter.noHubsFound': '未找到可同步的中心',
  'pages.controlCenter.syncAccepted': '已接受中心同步请求',
  'pages.controlCenter.robots.dazing.title': 'DazingLottie - 呼吸 + 眨眼',
  'pages.controlCenter.robots.dazing.desc':
    '使用 Lottie 动画库提供呼吸 + 眨眼动画效果',
  'pages.controlCenter.robots.thinking.title': 'ThinkingLottie - 眨眼 + 运行',
  'pages.controlCenter.robots.thinking.desc':
    '使用 Lottie 动画库提供眨眼 + 运行动画效果',
  'pages.controlCenter.robots.bouncing.title': 'BouncingLottie - 弹跳',
  'pages.controlCenter.robots.bouncing.desc':
    '使用 Lottie 动画库提供弹跳动画效果',
  'pages.controlCenter.robots.blowing.title': 'BlowingWindLottie - 吹风',
  'pages.controlCenter.robots.blowing.desc':
    '使用 Lottie 动画库提供吹风动画效果',
  'pages.controlCenter.robots.peek.title': 'PeekLottie - 偷看',
  'pages.controlCenter.robots.peek.desc': '使用 Lottie 动画库提供偷看动画效果',

  // XUDO Common
  'pages.xudo.deleteSuccess': '删除成功，即将刷新',
  'pages.xudo.deleteFailed': '删除失败，请重试',
  'pages.xudo.addSuccess': '添加成功',
  'pages.xudo.addFailed': '添加失败，请重试！',
  'pages.xudo.updateSuccess': '更新成功',
  'pages.xudo.updateFailed': '更新失败，请重试',
  'pages.xudo.pleaseSelectItems': '请选择删除项',
  'pages.xudo.game.selectGame': '请选择游戏',
  'pages.xudo.search.placeholder': '搜索 {field}',
  'pages.xudo.filter': '筛选',
  'pages.xudo.profile': '用户信息',
  'pages.xudo.close': '关闭',
  'pages.xudo.total': '共 {total} 项',

  // Game Column Status
  'pages.games.online': '在线',
  'pages.games.maintenanceStatus': '维护',
  'pages.games.play': '试玩',

  // Vendor Page
  'pages.vendor.title': '游戏厂商列表',
  'pages.vendor.new': '新建厂商',
  'pages.vendor.vendor': '厂商',
  'pages.vendor.code': '代码',
  'pages.vendor.gateway_id': '中心ID',
  'pages.vendor.status': '状态',
  'pages.vendor.status.sandbox': '沙盒',
  'pages.vendor.status.production': '生产',
  'pages.vendor.status.ban': '禁用',
  'pages.vendor.status.maintenance': '维护',
  'pages.vendor.updatedAt': '更新时间',
  'pages.vendor.operating': '操作',
  'pages.vendor.codeRequired': '厂商代码必填',
  'pages.vendor.codeLabel': '厂商代码',
  'pages.vendor.hubIdRequired': '中心ID必填',
  'pages.vendor.hubIdLabel': '中心ID',
  'pages.vendor.statusLabel': '状态',
  'pages.vendor.category': '游戏类型',
  'pages.vendor.currencies': '支持的货币',
  'pages.vendor.configSupported': '支持配置',
  'pages.vendor.yes': '是',
  'pages.vendor.no': '否',
  'pages.vendor.localizedLabels': '本地化标签',
  'pages.vendor.defaultSettings': '默认设置',
  'pages.vendor.images': '厂商图片',
  'pages.vendor.syncAllGame': '同步全部游戏',
  'pages.vendor.syncSuccess': '已同步 {vendors} 个厂商。Hub 中可用游戏 {games} 个。',
  'pages.vendor.syncFailed': '同步失败',

  // Gateway Page
  'pages.gateway.title': '中心列表',
  'pages.gateway.new': '新建中心',
  'pages.gateway.updateTitle': '中心配置',
  'pages.gateway.id': 'ID',
  'pages.gateway.code': '代码',
  'pages.gateway.codeRequired': '请输入中心代码',
  'pages.gateway.stage': '阶段',
  'pages.gateway.stage.sandbox': '沙盒',
  'pages.gateway.stage.production': '生产',
  'pages.gateway.status': '状态',
  'pages.gateway.status.active': '活跃',
  'pages.gateway.status.inactive': '未激活',
  'pages.gateway.currencies': '货币',
  'pages.gateway.updatedAt': '更新时间',
  'pages.gateway.operating': '操作',
  'pages.gateway.syncAll': '同步全部',
  'pages.gateway.sync': '同步',
  'pages.gateway.syncSuccess': '同步已成功启动',
  'pages.gateway.name': '名称',
  'pages.gateway.securityStrategy': '安全策略',
  'pages.gateway.systemEnvironment': '系统环境',
  'pages.gateway.syncFailed': '同步启动失败，请重试',
  'pages.gateway.connectionConfig': '连接配置',
  'pages.gateway.advancedConfig': '高级配置',

  // Game Page
  'pages.game.title': '游戏列表',
  'pages.game.new': '新建游戏',
  'pages.game.updateTitle': '游戏配置',
  'pages.game.basicInfo': '基本信息',
  'pages.game.game': '游戏',
  'pages.game.createdAt': 'เมื่อวันที่/เวลา',
  'pages.game.code': '代码',
  'pages.game.vendorId': '厂商ID',
  'pages.game.category': '类型',
  'pages.game.category.none': '通用',
  'pages.game.category.blockchain': '区块链',
  'pages.game.category.electronic': '电子',
  'pages.game.category.slot': '老虎机',
  'pages.game.category.table': '桌面游戏',
  'pages.game.category.live': '真人视讯',
  'pages.game.category.lottery': '彩票',
  'pages.game.category.fish': '捕鱼游戏',
  'pages.game.category.arcade': '街机',
  'pages.game.category.sport': '体育',
  'pages.game.category.esport': '电子竞技',
  'pages.game.officialStatus': '官方状态',
  'pages.game.status.active': '活跃',
  'pages.game.status.inactive': '未激活',
  'pages.game.status.maintenance': '维护',
  'pages.game.status.online': 'ONLINE',
  'pages.game.updatedAt': '更新时间',
  'pages.game.operating': '操作',
  'pages.game.play': '试玩',
  'pages.game.set-rtp': 'Set RTP',
  'pages.game.rtp': 'RTP',
  'pages.game.rtpConfig': 'RTP配置 - {name} ({id})',
  'pages.game.rtpLabel': '玩家回报率 (RTP) %',
  'pages.game.rtpUpdateSuccess': 'RTP更新成功',
  'pages.game.rtpUpdateFailed': 'RTP更新失败',
  'pages.game.rtpFetchFailed': '获取RTP失败',
  'pages.game.update': '更新',
  'pages.game.launch': '启动游戏',
  'pages.game.launchFailed': '启动游戏失败',
  'pages.game.launchUrlFailed': '获取启动URL失败',
  'pages.game.noGameSelected': '未选择游戏',
  'pages.game.gameDataNotFound': '未找到游戏数据',
  'pages.game.playerTokenNotFound': '未找到玩家访问令牌',
  'pages.game.missingData': '缺少游戏代码或厂商',
  'pages.game.codeRequired': '请输入游戏代码',
  'pages.game.vendorRequired': '请选择游戏厂商',
  'pages.game.labels': '本地化标签',
  'pages.game.settings': '官方设置',
  'pages.game.images': '游戏图片',

  // Owner Page
  'pages.owner.title': '所有者列表',
  'pages.owner.new': '新增所有者',
  'pages.owner.owner': '所有者',
  'pages.owner.name': '所有者名称',
  'pages.owner.nameRequired': '请输入所有者名称',
  'pages.owner.updateTitle': '所有者配置',
  'pages.owner.budgetConfig': '预算配置',
  'pages.owner.balance': '余额',
  'pages.owner.creditType': '信用类型',
  'pages.owner.creditType.seamless': '无缝 (Seamless)',
  'pages.owner.creditType.prepaid': '预付费 (Prepaid)',
  'pages.owner.currency': '货币',
  'pages.owner.initialLogin': '首次登录',
  'pages.owner.lastActiveTime': '最后活跃时间',
  'pages.owner.orgSection': '组织信息',
  'pages.owner.orgName': '组织名称',
  'pages.owner.orgNamePlaceholder': '例如：ACME公司',
  'pages.owner.orgCurrencies': '支持的货币',
  'pages.owner.orgCurrenciesPlaceholder': '选择货币',
  'pages.owner.ownerSection': '所有者信息',
  'pages.owner.ownerName': '姓名',
  'pages.owner.ownerNamePlaceholder': '例如：张三',
  'pages.owner.ownerUsername': '用户名（会员ID）',
  'pages.owner.ownerUsernamePlaceholder': '例如：zhangsan',
  'pages.owner.ownerUsernameTooltip': '这也将作为组织的子域名使用。',
  'pages.owner.ownerSubdomain': '认证/工作场所URL',
  'pages.owner.ownerSubdomainPlaceholder': '例如：dragon-node',
  'pages.owner.ownerSubdomainTooltip':
    '这也将用作组织的subdomain.backoffice.com。',
  'pages.owner.ownerSubdomainFinalize': '最终URL：',
  'pages.owner.ownerPhone': '电话号码（可选）',
  'pages.owner.invalidPhone': '无效的电话号码',
  'pages.owner.trialSection': '试用设置',
  'pages.owner.trialDays': '试用期（天）',

  // XCenter Page
  'pages.xcenter.title': 'X 控制中心',
  'pages.xcenter.description': '管理您的 AI 服务和资源分配',
  'pages.xcenter.mode': '{mode} 模式',
  'pages.xcenter.sandbox': '沙盒',
  'pages.xcenter.syncHubs': '同步所有中心',
  'pages.xcenter.saveConfig': '保存配置',
  'pages.xcenter.budgetBalance': '预算余额',
  'pages.controlCenter.bussinessRevenueBalance': 'Business Revenue Balance',
  'pages.xcenter.creditType': '信用类型',
  'pages.xcenter.activeHubs': '活跃中心',
  'pages.xcenter.online': '在线',
  'pages.xcenter.ownerName': '所有者名称',
  'pages.xcenter.id': 'ID',
  'pages.xcenter.lastUpdated': '最后更新',
  'pages.xcenter.ownerNotFound': '未找到所有者信息',
  'pages.xcenter.configSaved': '配置已保存',
  'pages.xcenter.configSaveFailed': '保存配置失败',
  'pages.xcenter.syncFailed': '请求中心同步失败',
  'pages.xcenter.noHubsFound': '未找到可同步的中心',
  'pages.xcenter.syncAccepted': '已接受中心同步请求',

  // Tools
  'pages.tools.magicEditor': '魔法编辑器',
  'pages.tools.cleanup': '清理',
  'pages.tools.magicEdit': '魔法编辑',
  'pages.tools.placeDesign': '放置设计',
  'pages.tools.colors': '颜色',
  'pages.tools.newImage': '上传新图片',
  'pages.tools.startCleanup': '开始清理',
  'pages.tools.detectRemoveLogos': '自动检测并移除徽标、水印和品牌。',
  'pages.tools.describeMagic': '描述您想要更改、添加或替换的内容。',
  'pages.tools.magicPlaceholder': '例如：将“新会员”更改为“欢迎”...',
  'pages.tools.applyEdit': '应用编辑',
  'pages.tools.uploadDesign': '上传要放置在图片上的设计或道具。',
  'pages.tools.clickToChange': '点击更换',
  'pages.tools.selectOverlay': '选择覆盖图片',
  'pages.tools.instructionOptional': '说明（可选）：',
  'pages.tools.placePlaceholder': '例如：将其放在衬衫中心...',
  'pages.tools.mergeDesign': '合并设计',
  'pages.tools.currentPalette': '当前调色板',
  'pages.tools.rescan': '重新扫描',
  'pages.tools.scanColors': '扫描颜色',
  'pages.tools.modifyTheme': '修改主题',
  'pages.tools.themePlaceholder': '例如：赛博朋克、柔和...',
  'pages.tools.syncColors': '同步颜色',
  'pages.tools.selectToolToBegin': '选择一个工具开始编辑。',
  'pages.tools.editsMade': '已完成 {count} 次编辑',
  'pages.tools.originalImage': '原始图片',
  'pages.tools.undo': '撤销',
  'pages.tools.download': '下载',
  'pages.tools.geminiWorking': 'Gemini 正在处理...',
  'pages.tools.noImageLoaded': '未加载图片',
  'pages.common.noData': '暂无数据',
  'pages.common.notfound': '暂无数据',
  'pages.common.key': '键',
  'pages.common.value': '值',
  'component.siteSelector.currentSiteLobby': 'Site Lobby',

  'pages.game.uat': 'Latest at',

  'pages.common.currencyNotSupported': 'Unsupported Currency',
  'pages.vendor.images.dragger.title': '单击或拖动文件到此区域进行上传',
  'pages.vendor.images.dragger.hint': '支持单次或批量上传',

  "pages.vendor.ggr.card.day": "Day",
  "pages.vendor.ggr.card.fees.maintenance": "Maintenance Fees",
  'pages.management.site-list.form.addAgain': '再次添加',

  // Management > Transactions
  'pages.management.transactions.txId': '交易ID',
  'pages.management.transactions.playerId': '玩家ID',
  'pages.management.transactions.gameId': '游戏ID',
  'pages.management.transactions.at': '时间',
  'pages.management.transactions.ref_code': '参考代码',
  'pages.management.transactions.betAmount': '下注',
  'pages.management.transactions.payoutAmount': '派彩',
  'pages.management.transactions.targetCompletion': '目标完成度',
  'pages.management.transactions.timeRemaining': '剩余时间',
  'pages.management.transactions.liveTps': '实时TPS',
  'pages.management.transactions.reqPerSec': '请求/秒',
  'pages.management.transactions.total': '共 {total} 项',

  // Vendor GGR Manager Page
  'pages.vendor.ggr.title': '供应商GGR管理器',
  'pages.vendor.ggr.subtitle': '收入分成与账单配置',
  'pages.vendor.ggr.org': '组织:',

  // Tabs
  'pages.vendor.ggr.tab.draft': '选择厂商',
  'pages.vendor.ggr.tab.configure': '配置GGR',
  'pages.vendor.ggr.tab.simulate': '模拟收入',

  // Draft Vendors Tab
  'pages.vendor.ggr.draft.title': '选择厂商',
  'pages.vendor.ggr.draft.subtitle': '选择要添加到您组织的厂商',
  'pages.vendor.ggr.draft.search': '搜索厂商...',
  'pages.vendor.ggr.draft.all': '全部',
  'pages.vendor.ggr.draft.available': '{count} 个可用厂商',
  'pages.vendor.ggr.draft.selected': '已选择 {count} 个',
  'pages.vendor.ggr.draft.noMatch': '没有符合条件的厂商',

  // Vendor Card
  'pages.vendor.ggr.card.ggrRate': 'GGR费率:',
  'pages.vendor.ggr.card.platform': '平台:',
  'pages.vendor.ggr.card.billing': '账单日:',
  'pages.vendor.ggr.card.fees': '费用:',

  // Configure GGR Tab
  'pages.vendor.ggr.config.title': 'GGR层级配置',
  'pages.vendor.ggr.config.subtitle': '配置收入分成比例和账单计划',
  'pages.vendor.ggr.config.selectTier': '选择要编辑的层级',
  'pages.vendor.ggr.config.selectTierEmpty': '选择层级',
  'pages.vendor.ggr.config.selectTierEmptyDesc':
    '从左侧选择一个层级来配置其设置',

  // GGR Tier Config Form
  'pages.vendor.ggr.config.minGGR': '最小GGR (USDT)',
  'pages.vendor.ggr.config.maxGGR': '最大GGR (USDT)',
  'pages.vendor.ggr.config.unlimited': '无限制',
  'pages.vendor.ggr.config.vendorRate': '厂商费率',
  'pages.vendor.ggr.config.platformRate': '平台费率',
  'pages.vendor.ggr.config.maintenanceFee': '维护费',
  'pages.vendor.ggr.config.serviceFee': '服务费',
  'pages.vendor.ggr.config.billingSchedule': '账单计划',
  'pages.vendor.ggr.config.billDay': '账单日',
  'pages.vendor.ggr.config.fineDays': '罚款天数',
  'pages.vendor.ggr.config.suspend': '暂停',
  'pages.vendor.ggr.config.terminate': '终止',

  // Simulate Revenue Tab
  'pages.vendor.ggr.simulate.title': '收入模拟',
  'pages.vendor.ggr.simulate.subtitle': '估算付款并查看账单计划',
  'pages.vendor.ggr.simulate.noVendors': '未选择厂商',
  'pages.vendor.ggr.simulate.noVendorsDesc': '从列表中选择厂商以模拟收入分成',

  // Revenue Simulator Cards
  'pages.vendor.ggr.simulate.totalGGR': '总GGR',
  'pages.vendor.ggr.simulate.totalGGRTooltip': '所选厂商的总游戏收入',
  'pages.vendor.ggr.simulate.vendorShare': '厂商份额',
  'pages.vendor.ggr.simulate.vendorShareTooltip': '预计支付给厂商的份额',
  'pages.vendor.ggr.simulate.platformShare': '平台份额',
  'pages.vendor.ggr.simulate.platformShareTooltip': '预计平台保留的份额',
  'pages.vendor.ggr.simulate.totalDue': '应付总额',
  'pages.vendor.ggr.simulate.totalDueTooltip': '包括维护费和服务费的总应付金额',

  // Revenue Distribution
  'pages.vendor.ggr.simulate.distribution': '收入分配',
  'pages.vendor.ggr.simulate.perVendor': '按厂商模拟',
  'pages.vendor.ggr.simulate.estimatedGGR': '预估GGR',
  'pages.vendor.ggr.simulate.vendor': '厂商:',
  'pages.vendor.ggr.simulate.platform': '平台:',
  'pages.vendor.ggr.simulate.fees': '费用:',
  'pages.vendor.ggr.simulate.total': '总计:',

  // Payment Schedule Table
  'pages.vendor.ggr.simulate.schedule': '付款计划与截止日期',
  'pages.vendor.ggr.simulate.table.vendor': '厂商',
  'pages.vendor.ggr.simulate.table.amount': '金额',
  'pages.vendor.ggr.simulate.table.due': '到期',
  'pages.vendor.ggr.simulate.table.fine': '罚款',
  'pages.vendor.ggr.simulate.table.suspend': '暂停',
  'pages.vendor.ggr.simulate.table.terminate': '终止',
  'pages.vendor.ggr.simulate.table.total': '总计',

  // Vendor GGR - Missing translations
  'pages.vendor.ggr.selectVendor': '选择厂商',
  'pages.vendor.ggr.tab.tiers': 'GGR层级',
  'pages.vendor.ggr.tab.contract': '合同',
  'pages.vendor.ggr.config.addFirstTier': '添加第一层',
  'pages.vendor.ggr.config.addTier': '添加层级',

  // Vendor Image Upload
  'pages.vendor.image.title': '厂商图片',
  'pages.vendor.image.subtitle': '管理厂商图片和分类',
  'pages.vendor.image.upload': '上传图片',
  'pages.vendor.image.uploadSuccess': '图片上传成功',
  'pages.vendor.image.uploadError': '图片上传失败',
  'pages.vendor.image.deleteSuccess': '图片删除成功',
  'pages.vendor.image.deleteError': '图片删除失败',
  'pages.vendor.image.vendorName': '厂商名称',
  'pages.vendor.image.categories': '分类',
  'pages.vendor.image.currentImages': '当前图片',
  'pages.vendor.image.invalidFile': '文件类型无效',
  'pages.vendor.image.fileTooLarge': '文件过大 (最大 2MB)',

  'pages.support.robot.welcome':
    '你好！我是你的 AI 助手。今天有什么我可以帮你的吗？',
  'pages.support.robot.placeholder': '想问什么就问吧...',

  // Exception Pages
  'pages.403.subTitle': '抱歉，您无权访问此页面。',
  'pages.403.buttonText': '返回首页',

  // Component: Footer
  'component.footer.copyright':
    '2026 EIGHT DRAGON GLOBAL. All rights reserved. ·',
  'component.footer.contact': '联系我们的官方网站',

  // Component: AvatarDropdown
  'pages.org.rtm.title': '实时监控',
  'pages.org.rtm.loading': '正在加载玩家会话...',
  'pages.org.rtm.error.title': '连接API失败',
  'pages.org.rtm.error.description': '请检查：',
  'pages.org.rtm.error.network': '您的网络连接处于活跃状态',
  'pages.org.rtm.error.server': 'API服务器正在运行于',
  'pages.org.rtm.error.cors': 'CORS配置正确',
  'pages.org.rtm.error.firewall': '防火墙未阻止请求',
  'pages.org.rtm.retry': '重试连接',
  'pages.org.rtm.attempt': '尝试',
  'pages.org.rtm.selectPlayer': '选择要监控的玩家',
  'pages.org.rtm.sessionId': '会话ID',
  'pages.org.rtm.playerId': '玩家ID',
  'pages.org.rtm.gateway': '网关',
  'pages.org.rtm.transactions': '交易',
  'pages.org.rtm.liveData': '实时数据流',
  'pages.org.rtm.totalSessions': '总会话数',
  'pages.org.rtm.playing': '游戏中',
  'pages.org.rtm.idle': '空闲',
  'pages.org.rtm.creating': '创建中',
  'pages.org.rtm.refresh': '刷新',
  'pages.org.rtm.player': '玩家',
  'pages.org.rtm.balance': '余额',
  'component.avatarDropdown.account': '账户',
  'component.avatarDropdown.logout': '退出登录',

  // Component: SiteSelector
  'component.siteSelector.title': '选择站点和玩家',
  'component.siteSelector.description': '选择站点以继续操作。',
  'component.siteSelector.selectLobby': '请选择要测试游戏的大厅站点',
  'component.siteSelector.placeholder': '选择大厅站点',
  'component.siteSelector.confirm': '启动游戏',
  'component.siteSelector.cancel': '取消',
  'component.siteSelector.refresh': '刷新玩家',
  'component.siteSelector.playerIdentifier': '玩家',
  'component.siteSelector.playerPlaceholder': '选择玩家...',
  'component.siteSelector.loadingSites': '正在加载站点...',
  'pages.player.transfer.title': '余额管理',
  'pages.player.transfer.siteBalanceError': '无法验证站点余额，交易中止。',
  'pages.player.transfer.insufficientSiteBalance':
    '站点余额不足！站点仅有 {balance}',
  'pages.player.transfer.insufficientPlayerBalance':
    '玩家余额不足！玩家仅有 {balance}',
  'pages.player.list.sendSMS': '发送短信',
  'pages.player.transfer.success': '交易成功',
  'pages.player.transfer.failed': '交易失败',
  'pages.player.transfer.walletContext': '钱包信息',
  'pages.player.transfer.player': '玩家',
  'pages.player.transfer.currentPlayerBalance': '当前玩家余额',
  'pages.player.transfer.siteBalance': '站点余额 (House)',
  'pages.player.transfer.sitePlayersBalance': '站点玩家余额 (总计)',
  'pages.player.transfer.transactionType': '交易类型',
  'pages.player.transfer.deposit': '存款 (给予玩家)',
  'pages.player.transfer.withdraw': '取款 (从玩家扣除)',
  'pages.player.transfer.amount': '金额',
  'pages.player.transfer.amountRequired': '金额必须大于 0',
  'pages.player.transfer.remark': '备注',
  'pages.player.transfer.remarkPlaceholder': '调整原因',

  'pages.player.drawer.title': '注册新玩家',
  'pages.player.drawer.sessionExpired': '注册会话已过期，请重试。',
  'pages.player.drawer.createSuccess': '玩家验证并创建成功！',
  'pages.player.drawer.verifyFailed': '验证失败',
  'pages.player.drawer.required': '此字段为必填项',
  'pages.player.drawer.step.accountInfo': '账户信息',
  'pages.player.drawer.otpSent': 'OTP 发送成功',
  'pages.player.drawer.regFailed': '注册失败',
  'pages.player.drawer.siteSelection': '选择站点',
  'pages.player.drawer.selectSite': '选择站点',
  'pages.player.drawer.phoneRequired': 'Phone Requires',
  'pages.player.drawer.playerDetails': '玩家详情',
  'pages.player.drawer.nickname': '昵称',
  'pages.player.drawer.nicknamePlaceholder': '显示名称',
  'pages.player.drawer.phoneNumber': '手机号码',
  'pages.player.drawer.invalidPhone': '手机号码格式无效',
  'pages.player.drawer.language': '语言',
  'pages.player.drawer.step.verification': '验证',
  'pages.player.drawer.verifyTitle': '验证手机号码',
  'pages.player.drawer.verifySubtitle': '请输入发送至 {phone} 的 6 位验证码',
  'pages.player.drawer.otpLength': '必须为 6 位数字',
  'pages.player.drawer.otpRequired': '请输入OTP',
  'pages.player.drawer.otpLengthError': 'OTP必须为6位数字',

  // Component: GameLaunchOverlay
  'component.gameLaunch.scanOrPress': '扫描二维码或点击按钮开始游戏',
  'component.gameLaunch.openNewWindow': '在新窗口中打开游戏',
  'component.gameLaunch.copyUrl': '复制 URL',
  'component.gameLaunch.copySuccess': 'URL 复制成功',
  'component.gameLaunch.copyFailed': '无法复制 URL',
  'component.gameLaunch.sessionToken': '会话令牌：',
  'component.gameLaunch.goToMonitor': '前往玩家监控',
  // Component: FullPageLoading
  'component.loading.tip': '...',

  // Component: MagicEditor
  'component.magicEditor.editsMade': '已完成 {count} 次编辑',
  'component.magicEditor.originalImage': '原始图片',
  'component.magicEditor.undo': '撤销',
  'component.magicEditor.download': '下载',
  'component.magicEditor.geminiWorking': 'Gemini 正在处理...',
  'component.magicEditor.noImageLoaded': '未加载图片',
  'component.magicEditor.detectRemoveLogos': '自动检测并移除徽标、水印和品牌。',
  'component.magicEditor.startCleanup': '开始清理',
  'component.magicEditor.describeMagic': '描述您想要更改、添加或替换的内容。',
  'component.magicEditor.magicPlaceholder': '例如：将"新会员"更改为"欢迎"...',
  'component.magicEditor.applyEdit': '应用编辑',
  'component.magicEditor.uploadDesign': '上传要放置在图片上的设计或道具。',
  'component.magicEditor.clickToChange': '点击更换',
  'component.magicEditor.selectOverlay': '选择覆盖图片',
  'component.magicEditor.instructionOptional': '说明（可选）：',
  'component.magicEditor.placePlaceholder': '例如：将其放在衬衫中心...',
  'component.magicEditor.mergeDesign': '合并设计',
  'component.magicEditor.currentPalette': '当前调色板',
  'component.magicEditor.rescan': '重新扫描',
  'component.magicEditor.scanColors': '扫描颜色',
  'component.magicEditor.modifyTheme': '修改主题',
  'component.magicEditor.themePlaceholder': '例如：赛博朋克、柔和...',
  'component.magicEditor.syncColors': '同步颜色',
  'component.magicEditor.selectToolToBegin': '选择一个工具开始编辑。',
  'component.magicEditor.agenticAI': 'Agentic AI',
  'component.magicEditor.uploadNewImage': '上传新图片',
  'component.magicEditor.newImage': '新图片',
  'component.magicEditor.cleanup': '清理',
  'component.magicEditor.magicEdit': '魔法编辑',
  'component.magicEditor.placeDesign': '放置设计',
  'component.magicEditor.colors': '颜色',
  'component.magicEditor.imageUploaded': '图片上传成功',
  'component.magicEditor.logosRemoved': '徽标已移除',
  'component.magicEditor.logoRemoveFailed': '移除徽标失败，请重试。',
  'component.magicEditor.editApplied': '编辑已应用',
  'component.magicEditor.editFailed': '处理编辑失败，请重试。',
  'component.magicEditor.colorsSynced': '颜色已同步',
  'component.magicEditor.recolorFailed': '重新着色失败，请重试。',
  'component.magicEditor.designPlaced': '设计已成功放置',
  'component.magicEditor.placeFailed': '放置设计失败，请重试。',
  'component.magicEditor.extractingPalette': '正在提取调色板...',
  'component.magicEditor.paletteExtracted': '调色板已提取',
  'component.magicEditor.paletteFailed': '提取调色板失败，请重试。',

  // Management: Player List
  'pages.management.players.title': '玩家管理',
  'pages.management.players.player': '玩家',
  'pages.management.players.anonymous': '匿名',
  'pages.management.players.id': 'ID',
  'pages.management.players.siteId': '站点 ID',
  'pages.management.players.currency': '货币',
  'pages.management.players.balance': '余额',
  'pages.management.players.status': '状态',
  'pages.management.players.status.active': '活跃',
  'pages.management.players.status.inactive': '未激活',
  'pages.management.players.status.banned': '已禁用',
  'pages.management.players.createdAt': '创建时间',
  'pages.management.players.total': '共 {total} 名玩家',
  'pages.management.players.transactionHistory': '交易记录',
  'management.playerDetail.title': '玩家详情',

  // Withdraw History
  'withdraw.history.createdAt': '创建时间',
  'withdraw.history.bonusName': '奖金名称',
  'withdraw.history.slip': '单据',
  'pages.player.list': '玩家列表',
  'pages.player.list.title': '玩家列表',
  'pages.player.list.id': 'ID',
  'pages.player.list.playerInfo': '玩家信息',
  'pages.player.list.balance': '余额',
  'pages.player.list.ggr': 'GGR',
  'pages.player.list.affiliate': '代理',
  'pages.player.list.createdAt': '创建时间',
  'pages.player.list.actions': '操作',
  'pages.player.list.transfer': '转账',
  'pages.layouts.userLayout.title': 'Version 1.0.0',
  'pages.player.list.delete': '删除',
  'pages.player.list.verified_phone': '已验证手机',
  'pages.player.list.ggrTooltip': '博彩总收入 (总投注 - 总赢额)',
  'pages.player.list.deleteConfirm': '确认删除?',
  'pages.player.list.total': '共 {total} 项',
  'pages.player.new': '新建玩家',
  'pages.player.modal.title': '注册新玩家',
  'pages.player.modal.tryRefreshSitesFirst': '请先刷新站点',
  'pages.player.modal.site': '站点',
  'pages.player.modal.currency': '货币',
  'pages.player.modal.close': '关闭',
  'pages.player.modal.register': '注册新玩家',
  'pages.player.modal.verify': '验证新玩家',
  'pages.player.modal.back': '返回',
  'pages.player.modal.verify.otp': '验证新玩家',
  'pages.player.modal.passwordInfo': '关于账户密码的信息',
  'pages.player.modal.passwordInfoSubtitle':
    '密码是根据手机号码自动生成的，并将发送到玩家的手机号码。',

  'pages.common.save': '保存',
  'pages.common.create': '创建',
  'pages.common.cancel': '取消',
  'pages.common.option': '选项',
  'pages.common.edit': '编辑',

  // Management: Transaction List
  'pages.management.transactions.profit': 'Profit',
  'pages.management.transactions.siteId': '站点 ID',
  'pages.management.transactions.amount': '金额',
  'pages.management.transactions.type': '类型',
  'pages.management.transactions.type.deposit': '存款',
  'pages.management.transactions.type.withdraw': '取款',
  'pages.management.transactions.type.transfer': '转账',
  'pages.management.transactions.type.bet': '投注',
  'pages.management.transactions.type.win': '获胜',
  'pages.management.transactions.status': '状态',
  'pages.management.transactions.status.success': '成功',
  'pages.management.transactions.status.pending': '待处理',
  'pages.management.transactions.status.failed': '失败',
  'pages.management.transactions.createdAt': '创建时间',

  // Management: Site Builder
  'pages.management.site-builder.comingSoon': '即将推出！',
  'pages.management.site-builder.onDevelopment': '正在为您开发站点构建器！',
  'pages.management.site-list.revenueSummary': '收入汇总',

  // Social Links
  'menu.settings.socialLinks': '社交链接',
  'pages.settings.socialLinks.saveSuccess': '保存成功',
  'pages.settings.socialLinks.saveError': '保存社交链接失败',
  'pages.settings.socialLinks.title': '社交链接',
  'pages.settings.socialLinks.description':
    '将您的社交媒体帐户连接到您的个人资料中显示',
  'pages.settings.socialLinks.website': '网站',
  'pages.settings.socialLinks.facebook': 'Facebook',
  'pages.settings.socialLinks.twitter': 'Twitter / X',
  'pages.settings.socialLinks.instagram': 'Instagram',
  'pages.settings.socialLinks.youtube': 'YouTube',
  'pages.settings.socialLinks.linkedin': 'LinkedIn',
  'pages.settings.socialLinks.github': 'GitHub',
  'pages.settings.socialLinks.discord': 'Discord',
  'pages.settings.socialLinks.telegram': 'Telegram',

  // XUDO: XHub
  'pages.xudo.xhub.search': '搜索',
  'pages.xudo.xhub.reset': '重置',
  'pages.xudo.xhub.searchPlaceholder': '搜索 {dataIndex}',
  'pages.xudo.xhub.healthy': '健康',
  'pages.xudo.xhub.selectItems': '请选择要删除的项目',

  // XUDO: XGame
  'pages.xudo.game.id': 'ID',
  'pages.xudo.game.gameCode': '游戏代码',
  'pages.xudo.game.vendorId': '厂商 ID',
  'pages.xudo.game.category': '类型',
  'pages.xudo.game.icons': '图标',
  'pages.xudo.game.maintenanceAt': '维护时间',
  'pages.xudo.game.maintenanceAnnouncement': '维护公告',
  'pages.xudo.game.createdAt': '创建时间',
  'pages.xudo.game.updatedAt': '更新时间',
  'pages.xudo.game.defaultConfig': '默认配置',
  'pages.xudo.game.launchFailed': '启动游戏失败',
  'pages.xudo.game.launching': '正在启动...',
  'pages.xudo.game.selectSiteTitle': '选择站点测试游戏',
  'pages.player.drawer.otpTitle': 'รหัสยืนยัน 6 หลัก',

  // XUDO: XHub Forms
  'pages.xudo.xhub.form.select': '选择',
  'pages.xudo.xhub.form.selectCountry': '请选择国家',
  'pages.xudo.xhub.form.maintenanceTooltip':
    '设置日期以安排维护。清除以设置为健康。',
  'pages.xudo.xhub.form.envTooltip':
    '中心环境的自定义键值对（例如 XGLOBAL_SITE, XGLOBAL_PUBLIC_KEY）',
  'pages.xudo.xhub.form.standardServerApis': '标准服务器 API',
  'pages.xudo.xhub.form.apiEndpointTooltip': '中心的主要 API 端点',
  'pages.xudo.xhub.form.apiPlaceholder': 'https://jsgame.live',
  'pages.xudo.xhub.form.igmHubSeamless': 'IGM Gateway Seamless',
  'pages.xudo.xhub.form.seamlessApis': 'Seamless API',
  'pages.xudo.xhub.form.seamlessPlaceholder': 'https://huidu.x8dg.uk',
  'pages.xudo.xhub.form.healthCheckPath': '健康检查路径',
  'pages.xudo.xhub.form.healthCheckPlaceholder': '/health',
  'pages.xudo.xhub.form.whitelistCidrs': '回调白名单 CIDR',
  'pages.xudo.xhub.form.cidrsTooltip': '允许回调的 IP 范围',
  'pages.xudo.xhub.form.rawConnectionConfig': '原始连接配置（其他字段）',
  'pages.xudo.xhub.form.rawConfigTooltip':
    '编辑上面未列出的 connection_config 中的其他键。',

  // Org: Analysis
  'pages.org.analysis.excelView': 'Excel 视图（即将推出）',
  'pages.org.analysis.csvView': 'CSV 视图（即将推出）',

  // Org: Monitor
  'pages.org.monitor.liveGrossRevenue': '实时总收入增长',
  'pages.org.monitor.watch': '观看',

  // Account: Settings - Base
  'pages.account.settings.base.areaCodeRequired': '请输入区号！',
  'pages.account.settings.base.phoneRequired': '请输入电话号码！',
  'pages.account.settings.base.updateSuccess': '基本信息更新成功',
  'pages.account.settings.base.submitText': '更新信息',
  'pages.account.settings.base.displayName': '显示名称',
  'pages.account.settings.base.displayNameRequired': '请输入您的姓名！',
  'pages.account.settings.base.username': '用户名',
  'pages.account.settings.base.usernameRequired': '请输入用户名！',
  'pages.account.settings.base.phoneNumber': '电话号码',
  'pages.account.settings.base.accountInfo': '账户信息',
  'pages.account.settings.base.userUid': '用户 UID',
  'pages.account.settings.base.orgId': '组织 ID',
  'pages.account.settings.base.systemRole': '系统角色',
  'pages.account.settings.base.orgRole': '组织角色',
  'pages.account.settings.base.accountStatus': '账户状态',
  'pages.account.settings.base.creditType': '信用类型',
  'pages.account.settings.base.usdtBalance': 'USDT 信用余额',
  'pages.account.settings.base.integrationSettings': '集成设置',
  'pages.account.settings.base.superiaProjectUrl': 'Superia 项目 URL',
  'pages.account.settings.base.superiaPublishableKey': 'Superia 公开密钥',
  'pages.account.settings.base.avatar': '头像',
  'pages.account.settings.base.changeAvatar': '更换头像',

  // Account: Settings - Security
  'pages.account.settings.security.strong': '强',
  'pages.account.settings.security.medium': '中',
  'pages.account.settings.security.weak': '弱',
  'pages.account.settings.security.accountPassword': '账户密码',
  'pages.account.settings.security.currentStrength': '当前密码强度：',
  'pages.account.settings.security.modify': '修改',
  'pages.account.settings.security.backupPhone': '备用手机',
  'pages.account.settings.security.boundPhone': '已绑定手机：',
  'pages.account.settings.security.backupQuestion': '安全问题',
  'pages.account.settings.security.noBackupQuestion':
    '未设置安全问题，安全问题可有效保护账户安全',
  'pages.account.settings.security.set': '设置',
  'pages.account.settings.security.backupEmail': '备用邮箱',
  'pages.account.settings.security.boundEmail': '已绑定邮箱：',
  'pages.account.settings.security.mfaDevice': 'MFA 设备',
  'pages.account.settings.security.noMfaDevice':
    '未绑定 MFA 设备，绑定后可进行二次确认',
  'pages.account.settings.security.bind': '绑定',

  // Account: Settings - Binding
  'pages.account.settings.binding.taobao': '绑定淘宝',
  'pages.account.settings.binding.taobaoNotBound': '当前未绑定淘宝账号',
  'pages.account.settings.binding.alxpay': '绑定支付宝',
  'pages.account.settings.binding.alxpayNotBound': '当前未绑定支付宝账号',
  'pages.account.settings.binding.dingtalk': '绑定钉钉',
  'pages.account.settings.binding.dingtalkNotBound': '当前未绑定钉钉账号',
  'pages.account.settings.binding.bind': '绑定',

  // Account: Center
  'pages.account.center.assetBalance': '资产余额',
  'pages.account.center.creditLimit': '信用额度',
  'pages.account.center.wallet': '钱包',
  'pages.account.center.increase': '增加',
  'pages.account.center.card': '卡片',
  'pages.account.center.confirmed': '已确认',
  'pages.account.center.success': '成功',
  'pages.account.center.binance': 'BINANCE',
  'pages.account.center.instant': '即时',
  'pages.account.center.publishedAt': '发布于',

  // Welcome Page
  'pages.welcome.title': '欢迎使用 iGM Backoffice',
  'pages.welcome.description':
    'iGM Backoffice 是一个整合了 umi、Ant Design 和 ProComponents 的综合平台。致力于为游戏运营管理、玩家管理和站点配置提供无缝体验。',
  'pages.welcome.learnMore': '了解更多',
  'pages.welcome.card1.title': '了解 umi',
  'pages.welcome.card1.desc':
    'umi 是一个可扩展的企业级前端应用框架，以路由为基础，同时支持配置式路由和约定式路由。',
  'pages.welcome.card2.title': '了解 Ant Design',
  'pages.welcome.card2.desc':
    'antd 是基于 Ant Design 设计体系的 React UI 组件库，主要用于研发企业级中后台产品。',
  'pages.welcome.card3.title': '了解 Pro Components',
  'pages.welcome.card3.desc':
    'ProComponents 是一个基于 Ant Design 的高度抽象模板组件库，以一个组件就是一个页面为开发理念。',

  // Result: Fail
  'pages.result.fail.title': '提交失败',
  'pages.result.fail.subTitle': '请核对并修改以下信息后，再重新提交。',
  'pages.result.fail.errorTitle': '您提交的内容有如下错误：',
  'pages.result.fail.accountFrozen': '您的账户已被冻结',
  'pages.result.fail.unfreezeNow': '立即解冻',
  'pages.result.fail.notEligible': '您的账户还不具备申请资格',
  'pages.result.fail.upgradeNow': '立即升级',
  'pages.result.fail.returnToModify': '返回修改',

  // Result: Success
  'pages.result.success.title': '提交成功',
  'pages.result.success.subTitle':
    '提交结果页用于反馈一系列操作任务的处理结果。如果仅是简单操作，使用 Message 全局提示反馈即可。本文区域可以展示简单的补充说明。',
  'pages.result.success.backToList': '返回列表',
  'pages.result.success.viewProject': '查看项目',
  'pages.result.success.print': '打印',
  'pages.result.success.projectName': '项目名称',
  'pages.result.success.projectId': '项目 ID',
  'pages.result.success.principal': '负责人',
  'pages.result.success.effectiveTime': '生效时间',
  'pages.result.success.createProject': '创建项目',
  'pages.result.success.departmentReview': '部门审核',
  'pages.result.success.financialReview': '财务审核',
  'pages.result.success.finish': '完成',
  'pages.result.success.urge': '催一下',

  // Quota & Billing
  'pages.fund.title': '配额与账单',
  'pages.fund.tab.asset': '资产',
  'pages.fund.subtitle': '管理您的网站配额和账单',
  'pages.fund.packages.title': '可用套餐',
  'pages.fund.packages.sites': '网站套餐',
  'pages.fund.packages.storage': '存储套餐',
  'pages.fund.packages.bandwidth': '带宽套餐',
  'pages.fund.currentUsage': '当前使用量',
  'pages.fund.totalSites': '网站总数',
  'pages.fund.sitesUsed': '已用网站',
  'pages.fund.sitesRemaining': '剩余网站',
  'pages.fund.buyQuota': '购买配额',
  'pages.fund.purchase': '购买',
  'pages.fund.paymentMethod': '支付方式',
  'pages.fund.crypto': '加密货币',
  'pages.fund.price': '价格',
  'pages.fund.quantity': '数量',
  'pages.fund.total': '总计',
  'pages.fund.status': '状态',
  'pages.fund.active': '活跃',
  'pages.fund.pending': '待处理',
  'pages.fund.completed': '已完成',
  'pages.fund.discount': '折扣',
  'pages.fund.popular': '热门',
  'pages.fund.perSite': '每网站',
  'pages.fund.savings': '节省',

  // Billing
  'pages.billing.title': '账单',
  'pages.billing.balance': '余额',
  'pages.billing.availableBalance': '可用余额',
  'pages.billing.topup': '充值',
  'pages.billing.topupCrypto': '使用加密货币充值',
  'pages.billing.topupAmount': '充值金额',
  'pages.billing.selectCurrency': '选择货币',
  'pages.billing.paymentAddress': '支付地址',
  'pages.billing.copyAddress': '复制地址',
  'pages.billing.copied': '已复制！',
  'pages.billing.waitingPayment': '等待支付...',
  'pages.billing.paymentConfirmed': '支付已确认！',
  'pages.billing.paymentExpired': '支付已过期',
  'pages.billing.transactionHistory': '交易历史',
  'pages.billing.noTransactions': '未找到交易',
  'pages.billing.date': '日期',
  'pages.billing.type': '类型',
  'pages.billing.deposit': '存款',
  'pages.billing.purchase': '购买',
  'pages.billing.refund': '退款',

  // Payment Modal
  'pages.payment.step.creating': '创建中',
  'pages.payment.step.payment': '支付',
  'pages.payment.step.complete': '完成',
  'pages.payment.creatingRequest': '正在创建您的支付请求...',
  'pages.payment.creatingUsdtRequest': '正在创建您的 USDT 支付请求...',
  'pages.payment.details': '支付详情',
  'pages.payment.usdtDetails': 'USDT 支付详情',
  'pages.payment.waiting': '等待支付...',
  'pages.payment.amount': '金额',
  'pages.payment.amountToPay': '需支付金额',
  'pages.payment.usdValue': '美元价值',
  'pages.payment.fund': '配额',
  'pages.payment.siteName': '站点名称',
  'pages.payment.network': '网络',
  'pages.payment.scanToPay': '扫码支付',
  'pages.payment.sendExactly': '请准确发送 {amount} {currency}',
  'pages.payment.copy': '复制',
  'pages.payment.address': '地址',
  'pages.payment.received': '已收到: {amount} {currency}',
  'pages.payment.expiresAt': '此支付请求将于 {date} 过期',
  'pages.payment.important': '重要提示:',
  'pages.payment.warningNetwork': '请仅在此网络上发送 USDT!',
  'pages.payment.warningSendOnly': '• 请仅在 {network} 网络上发送 USDT',
  'pages.payment.warningLoss': '• 发送其他代币或使用错误网络可能导致永久损失',
  'pages.payment.warningExact': '• 请准确发送上述金额',
  'pages.payment.success.title': '支付完成!',
  'pages.payment.success.quotaAdded':
    '您的配额已添加，站点 "{siteName}" 正在配置中',
  'pages.payment.success.topupAdded': '您的充值 ${amount} 已添加到余额',
  'pages.payment.success.viewSites': '查看我的站点',
  'pages.payment.success.close': '关闭',
  'pages.payment.failed.title': '支付失败',
  'pages.payment.failed.subtitle': '无法处理支付，请重试',
  'pages.payment.failed.close': '关闭',
  'pages.payment.error.create': '创建支付失败',
  'pages.payment.cancelled': '支付已取消',

  // Organization Hierarchy
  'pages.login.pleaseVerifyCaptcha': 'Please verify that you are not a robot.',
  'pages.org.hierarchy.member': '成员',
  'pages.org.hierarchy.operator': '操作员',
  'pages.org.hierarchy.operators': '操作员',

  // Site Hierarchy
  'pages.site.hierarchy.environment': '环境',
  'pages.site.hierarchy.player': '玩家',
  'pages.site.hierarchy.players': '玩家',

  // Player Detail
  'player.detail.title': '玩家详情',
  'player.detail.profile': '个人资料',
  'player.detail.nickname': '昵称',
  'player.detail.registeredAt': '注册时间',
  'player.detail.phone': '电话',
  'player.detail.affiliateFrom': '推荐来源',
  'player.detail.playerCountryCode': '首选语言',
  'player.detail.preferredCurrency': '首选货币',
  'player.detail.uat': 'UAT',
  'player.detail.creditBalance': '余额',
  'player.detail.export': '导出',
  'player.detail.player.username': '用户名',

  // Player History
  'player.detail.history.createdAt': '创建时间',
  'player.detail.history.bonusName': '奖金名称',
  'player.detail.history.source': '来源',
  'player.detail.history.amount': '金额',
  'player.detail.history.before': '之前',
  'player.detail.history.after': '之后',
  'player.detail.history.bonus': '奖金',
  'player.detail.history.received': '已收到',
  'player.detail.history.turnover': '流水',
  'player.detail.history.status': '状态',
  'player.detail.history.updatedBy': '更新者',

  // Withdraw Info
  'player.detail.withdrawInfo': '提款信息',
  'player.detail.withdraw.date': '日期',
  'player.detail.withdraw.amount': '金额',
  'player.detail.withdraw.bankName': '银行名称',
  'player.detail.withdraw.accountNo': '账户号码',
  'player.detail.withdraw.accountName': '账户名称',
  'player.detail.withdraw.source': '来源',
  'player.detail.withdraw.note': '备注',

  // Missing translations from error logs
  'pages.game.id': '游戏ID',
  'pages.game.maintenance': '维护状态',
  'fund.tab.asset.title': '资产',
  'fund.balance.pending.label': '待处理',

  // Fund topup form
  'fund.topup.form.selectCrypto': '选择加密货币进行充值',
  'fund.topup.form.amountLabel': '输入投资金额',
  'fund.topup.form.minAmountHint': '最低 {amount} {currency}',
  'fund.topup.form.submit': '充值 {amount}',
  'fund.topup.form.exchangeNotice': '您的 {crypto} 将按当前汇率自动转换为USDT',
  'fund.topup.form.finalCurrency': '所有资金将以USDT形式记入',
  'fund.message.topup.minAmountWarning': '最低金额未达到',
  'fund.message.topup.success': '充值成功',
  'fund.table.column.date': '日期',
  'fund.table.column.type': '类型',
  'fund.table.column.amount': '金额',
  'fund.table.column.status': '状态',
  'fund.table.column.order': '订单',
  'fund.table.column.description': '描述',
  'fund.tab.vault.title': '保险库',
  'fund.transactions.title': '交易记录',
  'fund.status.completed': '已完成',
  'fund.status.pending': '待处理',
  'fund.status.processing': '处理中',
  'fund.status.failed': '失败',
  'fund.status.rejected': '被拒绝',
  'fund.transactions.action.viewDetails': '查看详情',
  'fund.transactions.action.downloadReceipt': '下载收据',
  'pages.fund.purchase.disabled': '套餐购买已禁用',
  'pages.fund.purchase.disabledMessage': '套餐购买功能已被移除。请联系支持团队申请资金。',
  'pages.fund.purchase.close': '关闭',
  'fund.topup.modal.paymentRejected': '支付被拒绝',
  'fund.topup.modal.paymentRejectedMessage': '您的支付被拒绝。请重试。',
  'fund.topup.modal.close': '关闭',
  'fund.topup.modal.creating': '创建中',
  'fund.topup.modal.payment': '支付',
  'fund.topup.modal.done': '完成',
  'fund.topup.modal.preparingAddress': '正在准备您的{cryptoLabel}支付地址...',
  'fund.topup.modal.autoConverted': '自动转换为USDT',
  'fund.topup.modal.copyAddress': '复制地址',
  'fund.topup.modal.copyExactAmount': '复制精确金额 — {amount} {crypto}',
  'fund.topup.modal.expiresAt': '到期时间',
  'fund.topup.modal.sendOnly': '仅在{networkLabel}上发送{cryptoLabel}',
  'fund.topup.modal.paymentReceived': '支付已收到！',
  'fund.topup.modal.paymentReceivedMessage': '{amount} USD已添加到您的USDT余额',
  'fund.crypto.searchPlaceholder': '搜索货币（例如：USDT, BTC, TRX...）',
  'fund.crypto.autoExchangeEnabled': '自动兑换已启用',
  'fund.crypto.autoExchangeNotice': '将自动转换为 USDT 以符合当前市场汇率',

  // Redis Error Messages
  'pages.redis.missingConfig': '此站点缺少 Redis 配置',
  'pages.redis.clientNotInitialized': 'Redis 连接未建立。请尝试重新切换站点。',

  'brand.fetchError': '获取品牌配置失败',
  'brand.saveSuccess': '品牌配置保存成功',
  'brand.saveError': '保存品牌配置失败',
  'brand.social.saveSuccess': '社交媒体链接保存成功',
  'brand.social.saveError': '保存社交媒体链接失败',
  'brand.manifest.saveSuccess': 'Manifest 设置保存成功',
  'brand.manifest.saveError': '保存 Manifest 设置失败',
  "pages.playerFinanceOperations.title": "Processing Transactions",
  'brand.noSite': '未选择站点',
  'brand.noSite.desc': '请选择一个站点以管理品牌和主题设置。',
  'brand.tab.design': '设计与资产',
  'brand.tab.social': '社交媒体',
  'brand.tab.manifest': 'PWA Manifest',
  'brand.siteName': '站点显示名称',
  'brand.siteName.extra': '站点的公开名称',
  'brand.logo': '品牌 Logo URL',
  'brand.logo.extra': '建议尺寸：512x512px (PNG/WebP)',
  'brand.themeColor': '主题颜色',
  'brand.themeColor.desc': '品牌的主要颜色',
  'brand.secondaryColor': '次要主题颜色',
  'brand.secondaryColor.desc': '次要装饰颜色',
  'brand.bgColor': '背景颜色',
  'brand.bgColor.desc': '主站背景颜色 (--bg-color)',
  'brand.bgColorLobby': '大厅背景颜色',
  'brand.bgColorLobby.desc': '游戏大厅的背景颜色 (--bg-color-lobby)',
  'brand.bgSidebar': '侧边栏背景颜色',
  'brand.bgSidebar.desc': '侧边栏的背景颜色 (--bg-sidebar)',
  'brand.surfaceColor': '表面颜色',
  'brand.surfaceColor.desc': '卡片和弹出层颜色 (--surface-color)',
  'brand.gameCardColor': '游戏卡片颜色',
  'brand.gameCardColor.desc': '游戏卡片的背景颜色 (--game-card-color)',
  'brand.bgCardColor': '卡片背景叠加',
  'brand.bgCardColor.desc': '卡片的叠加背景颜色 (--bg-card-color)',
  'brand.textColor': '主要文字颜色',
  'brand.textColor.desc': '主要文字颜色 (--foreground-primary-color)',
  'brand.textSecondaryColor': '次要文字颜色',
  'brand.textSecondaryColor.desc': '次要/淡化文字颜色 (--foreground-secondary-color)',
  'brand.dividerColor': '分割线颜色',
  'brand.dividerColor.desc': '各区域间的分割线颜色 (--divider-color)',
  'brand.borderColor': '边框颜色',
  'brand.borderColor.desc': '输入框和卡片的边框颜色 (--border-color)',
  'brand.ringColor': '光圈颜色',
  'brand.ringColor.desc': '焦点和光圈颜色 (--ring-color)',
  'brand.accentColor': '强调色',
  'brand.accentColor.desc': '额外的强调高亮色 (--accent-color)',
  'brand.textMuted': '淡化文字',
  'brand.textMuted.desc': '小标签和提示文字 (--text-muted)',
  'brand.textLightest': '最亮文字',
  'brand.textLightest.desc': '纯白色文字 (--text-lightest)',
  'brand.textLightest90': '最亮文字 (90%)',
  'brand.textLightest90.desc': '带微透明的白色文字 (--text-lightest-90)',
  'brand.bgActiveMenu': '激活菜单背景',
  'brand.bgActiveMenu.desc': '侧边栏项的激活状态 (--bg-active-menu-item)',
  'brand.secondaryDarker': '次要深色',
  'brand.secondaryDarker.desc': '次要颜色的深色变体 (--secondary-darker)',
  'brand.background': '自定义背景',
  'brand.background.desc': '自定义背景渐变或颜色 (--brand-background)',
  'brand.customCss': '自定义 Root 变量 (CSS)',
  'brand.customCss.extra': '输入原始 CSS (例如 :root { --my-var: val; })',
  'brand.bgImage': '背景图 URL',
  'brand.bgImage.extra': '站点背景图或遮罩的 URL',
  'brand.ogBanner': 'Meta OG 横幅图 URL',
  'brand.ogBanner.extra': 'Open Graph 横幅图 URL (建议 1200x630)',
  'brand.bgSidebarImage': '侧边栏背景图 URL',
  'brand.bgSidebarImage.extra': '侧边栏背景图 URL (建议尺寸: 300x1080px 或更高)',
  'brand.blurSidebar': '模糊侧边栏',
  'brand.blurSidebar.extra': '为侧边栏应用玻璃拟态模糊效果',
  'brand.showSiteTitle': '显示站点标题',
  'brand.showSiteTitle.extra': '在浏览器标签和页眉中显示站点名称',
  'brand.importTheme': '导入主题',
  'brand.exportTheme': '导出主题',
  'brand.save': '保存设计设置',
  'brand.facebook': 'Facebook',
  'brand.x': 'X (Twitter)',
  'brand.telegram': 'Telegram',
  'brand.whatsapp': 'WhatsApp',
  'brand.line': 'LINE',

  // Manifest
  'manifest.name': '应用名称',
  'manifest.shortName': '短名称',
  'manifest.shortName.desc': '当空间有限时（如主屏幕）使用',
  'manifest.description': '描述',
  'manifest.display': '显示模式',
  'manifest.orientation': '屏幕方向',
  'manifest.themeColor': '主题颜色 (PWA)',
  'manifest.backgroundColor': '背景颜色 (Splash)',
  'manifest.save': '保存 Manifest 设置',

  // Payment Management
  'pages.management.payment.title': '支付管理',
  'pages.management.payment.subTitle': '管理充值和提现渠道',
  'pages.management.payment.table.channel': '渠道',
  'pages.management.payment.table.limits': '限额',
  'pages.management.payment.table.min': '最小',
  'pages.management.payment.table.max': '最大',
  'pages.management.payment.table.fee': '手续费',
  'pages.management.payment.table.availability': '可用性',
  'pages.management.payment.table.status': '状态',
  'pages.management.payment.table.accountNo': '账号',
  'pages.management.payment.table.accountName': '户名',
  'pages.management.payment.status.online': '系统在线',
  'pages.management.payment.status.maintenance': '系统维护',
  'pages.management.payment.message.updateSuccess': '状态已更新',
  'pages.management.payment.message.updateFailed': '更新状态失败',

  'pages.playerFinanceOperations.filter.search': '搜索',
  'pages.playerFinanceOperations.filter.searchPlaceholder': 'REF、玩家或账号',
  'pages.playerFinanceOperations.filter.type': '类型',
  'pages.playerFinanceOperations.filter.dateTime': '日期时间',
  'pages.playerFinanceOperations.filter.status': '状态',
  'pages.playerFinanceOperations.table.transaction': '交易',
  'pages.playerFinanceOperations.table.note': '备注',
  'pages.playerFinanceOperations.table.settledAt': '已结算',
  'pages.playerFinanceOperations.type.deposit': '存款',
  'pages.playerFinanceOperations.type.withdrawal': '取款',
  'pages.playerFinanceOperations.status.pending': '待审核',
  'pages.playerFinanceOperations.status.settlement': '结算中',
  'pages.playerFinanceOperations.status.succeeded': '成功',
  'pages.playerFinanceOperations.status.failed': '失败',
  'pages.playerFinanceOperations.status.cancelled': '已取消',
  'pages.playerFinanceOperations.status.expired': '已过期',
  'brand.lobbies.add': '联系您的管理员以添加站点入口',
  'brand.lobbies.add.subdomain': '添加子域名入口',
  'brand.lobby.cname.title': 'DOMAIN',
  'brand.lobby.cname.setup': '设置',
  'brand.lobby.cname.step1.title': '登录您的 DNS 提供商',
  'brand.lobby.cname.step1.desc': '添加以下 DOMAIN 记录：',
  'brand.lobby.cname.name': '名称',
  'brand.lobby.cname.target': '目标',
  'brand.lobby.cname.step2.title': '保存更改',
  'brand.lobby.cname.step2.desc': '添加记录后，点击检查 DNS 记录以启动验证检查。',
  'brand.lobby.cname.checkDns': '检查 DNS 记录',
  'brand.lobby.cname.note': '如果您的记录配置正确，将自动启用。DNS 更改可能需要最多 24 小时才能在全球范围内更新。',

  // Merchant Accounts
  'pages.common.placeholder.select': '请选择...',
  'pages.common.placeholder.input': '请输入...',
  'pages.common.search': '搜索',
  'pages.common.submit': '提交',
  'pages.common.reset': '重置',
  'brand.lobby.featured_vendors': '推荐游戏商',
  'brand.action': '操作',
  'brand.delete.confirm': '确定要删除此项吗？',
  'brand.category.manage': '管理游戏分类',
};
